export default {
    customer:{
        name:'企业',
        name_placeholder:'请输入企业名称',
        short_name:"企业简介",
        short_name_placeholder:"请输入企业简介",
        customer_code:'企业ID',
        customer_code_placeholder:'请输入企业ID',
        customer_status:'状态',
        customer_type:'企业类型',
        area:'区域',
        area_placeholder:'请输入区域',
        area_code:'编码',
        area_code_placeholder:'请输入编码',
        address:'地址',
        address_placeholder:'请输入地址',
        contact:'联系人',
        contact_placeholder:'请输入联系人',
        phone:'手机/电话号码',
        phone_placeholder:'请输入手机/电话号码',
        email:'电子邮箱',
        email_placeholder:'请输入电子邮箱',
        noti_methods:'通知客户',
        noti_methods_email:'邮件通知',
        noti_methods_mobile:'短信通知',
        description:'描述',

        //提示
        tip_before_del:"删除企业时，将会其关联到的范围、设备、用户等资源删除，是否确认删除？",
        tip_before_canc:"注销企业时,将会将相关联角色/用户/监测工具/资产停用,是否确定注销？",
        tip_actived:"激活成功",
        tip_cancelled:"注销成功",

        //模式切换
        mode_edit:'编辑模式',
        mode_lookup:'查阅模式',

        //对话框标题
        title_add:'新增企业',
        title_detail:'企业信息',
        title_edit_detail:'编辑企业',



        //返回的状态码
        code_200:'新增成功',
        code_201:'创建企业成功，但创建默认角色失败',
        code_202:'创建企业，默认角色成功，但创建用户失败',
        code_203:'创建企业，默认角色，用户成功，但同步联系人失败',
        code_406:'企业ID只能填写大小写英文字母，数字且不能大于20长度',
        code_410:'企业类型不能为空',
        code_418:'已存在相同的企业名称',
        code_420:'已存在相同的企业ID',
        code_421:'已存在相同的电子邮箱',
        code_422: '已存在相同的手机号码',



    }
}
